export default "__VITE_ASSET__CSwCMknt__"